/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ionic-angular/components/app/overlay-portal';
import * as import2 from 'ionic-angular/components/app/app';
import * as import3 from 'ionic-angular/config/config';
import * as import4 from 'ionic-angular/platform/platform';
import * as import5 from 'ionic-angular/gestures/gesture-controller';
import * as import6 from 'ionic-angular/transitions/transition-controller';
import * as import7 from 'ionic-angular/navigation/deep-linker';
import * as import8 from 'ionic-angular/platform/dom-controller';
import * as import9 from 'ionic-angular/components/app/click-block';
import * as import10 from 'ionic-angular/components/app/app-root';
const styles_IonicApp:any[] = ([] as any[]);
export const RenderType_IonicApp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_IonicApp,
  data: {}
}
);
export function View_IonicApp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{_viewport: 0}),
    import0.ɵqud(402653184,2,{_modalPortal: 0}),
    import0.ɵqud(402653184,3,{_overlayPortal: 0}),
    import0.ɵqud(402653184,4,{_loadingPortal: 0}),
    import0.ɵqud(402653184,5,{_toastPortal: 0}),
    (l()(),import0.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'viewport',
        1
      ]

    ]
      ,(null as any),0,'div',[[
        'app-viewport',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(16777216,[[
        'modalPortal',
        1
      ]
      ],(null as any),1,'div',[[
        'overlay-portal',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(147456,[[
        2,
        4
      ]
    ],0,import1.OverlayPortal,[
      import2.App,
      import3.Config,
      import4.Platform,
      import0.ElementRef,
      import0.NgZone,
      import0.Renderer,
      import0.ComponentFactoryResolver,
      import5.GestureController,
      import6.TransitionController,
      [
        2,
        import7.DeepLinker
      ]
      ,
      import0.ViewContainerRef,
      import8.DomController,
      import0.ErrorHandler
    ]
      ,{_overlayPortal: [
        0,
        '_overlayPortal'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(16777216,[[
        'overlayPortal',
        1
      ]
      ],(null as any),1,'div',[[
        'overlay-portal',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(147456,[[
        3,
        4
      ]
    ],0,import1.OverlayPortal,[
      import2.App,
      import3.Config,
      import4.Platform,
      import0.ElementRef,
      import0.NgZone,
      import0.Renderer,
      import0.ComponentFactoryResolver,
      import5.GestureController,
      import6.TransitionController,
      [
        2,
        import7.DeepLinker
      ]
      ,
      import0.ViewContainerRef,
      import8.DomController,
      import0.ErrorHandler
    ]
      ,{_overlayPortal: [
        0,
        '_overlayPortal'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(16777216,[[
        'loadingPortal',
        1
      ]
    ],(null as any),1,'div',[
      [
        'class',
        'loading-portal'
      ]
      ,
      [
        'overlay-portal',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(147456,[[
        4,
        4
      ]
    ],0,import1.OverlayPortal,[
      import2.App,
      import3.Config,
      import4.Platform,
      import0.ElementRef,
      import0.NgZone,
      import0.Renderer,
      import0.ComponentFactoryResolver,
      import5.GestureController,
      import6.TransitionController,
      [
        2,
        import7.DeepLinker
      ]
      ,
      import0.ViewContainerRef,
      import8.DomController,
      import0.ErrorHandler
    ]
      ,{_overlayPortal: [
        0,
        '_overlayPortal'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(16777216,[[
        'toastPortal',
        1
      ]
      ],(null as any),1,'div',[[
        'class',
        'toast-portal'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(147456,[[
        5,
        4
      ]
    ],0,import1.OverlayPortal,[
      import2.App,
      import3.Config,
      import4.Platform,
      import0.ElementRef,
      import0.NgZone,
      import0.Renderer,
      import0.ComponentFactoryResolver,
      import5.GestureController,
      import6.TransitionController,
      [
        2,
        import7.DeepLinker
      ]
      ,
      import0.ViewContainerRef,
      import8.DomController,
      import0.ErrorHandler
    ]
      ,{_overlayPortal: [
        0,
        '_overlayPortal'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'click-block'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import9.ClickBlock,[
      import2.App,
      import3.Config,
      import4.Platform,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = '';
    ck(v,7,0,currVal_0);
    const currVal_1:any = '';
    ck(v,9,0,currVal_1);
    const currVal_2:any = '';
    ck(v,11,0,currVal_2);
    const currVal_3:any = 10000;
    ck(v,13,0,currVal_3);
  },(null as any));
}
function View_IonicApp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-app',([] as any[]),(null as any),(null as any),(null as any),View_IonicApp_0,RenderType_IonicApp)),
    import0.ɵdid(114688,(null as any),0,import10.IonicApp,[
      import10.AppRootToken,
      import0.ComponentFactoryResolver,
      import0.ElementRef,
      import0.Renderer,
      import3.Config,
      import4.Platform,
      import2.App
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const IonicAppNgFactory:import0.ComponentFactory<import10.IonicApp> = import0.ɵccf('ion-app',import10.IonicApp,View_IonicApp_Host_0,{
  color: 'color',
  mode: 'mode'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/app/app-root.ngfactory.ts